import { Component, OnInit } from '@angular/core';
import * as packageJson from '../../../package.json';

@Component({
  selector: 'app-help-page',
  imports: [],
  templateUrl: './help-page.component.html',
  styleUrl: './help-page.component.scss',
  standalone: true,
})
export class HelpPageComponent implements OnInit {
  public appVersion: string;
  public apiVersion: string;
  constructor() {
    this.appVersion = packageJson.version;
    this.apiVersion="";
  }
  ngOnInit(): void {}
}
